'use strict';

class OrganizationsTemplateController {
  constructor($timeout,
              $scope,
              $filter,
              $state,
              utils,
              config,
              OrganizationService,
              ToastsService) {

    const $t = $filter('translate');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';

    $('.ui.accordion').accordion();
    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.emailTemplates = config.getConfigByKey('email-templates');

    let name = $state.params && $state.params.name;
    for (let i = 0; i < $scope.emailTemplates.length; i++) {
      if ($scope.emailTemplates[i].name == name) {
        $scope.template = $scope.emailTemplates[i];
        break;
      }
    }

    $scope.updateTemplate = function() {
      let properties = [
        {
          'name': $scope.template.subject,
          'value': $scope.subject,
          'privateContent': false
        }, {
          'name': $scope.template.title,
          'value': $scope.title,
          'privateContent': false
        }, {
          'name': $scope.template.subtitle,
          'value': $scope.subtitle,
          'privateContent': false
        }, {
          'name': $scope.template.text,
          'value': $scope.text,
          'privateContent': false
        }, {
          'name': $scope.template.filename,
          'value': $scope.filename,
          'privateContent': false
        }
      ];

      if ($scope.template.name.toLowerCase() != 'invite') {
        properties.push({
          'name': $scope.template.email,
          'value': $scope.email ? '1' : '0',
          'privateContent': false
        });
      }

      saveOrgProperties(properties).then(function(data) {
        if (data.resultCode != 0) {
          return;
        }
        ToastsService.success();
        if ($scope.uploadFinished == true) {
          $timeout(function() {
            $state.go('main.organizations.edit', {
              tab: 'templates'
            });
          }, 2000);
        }
      });

    };

    function removeTemplateFile() {
      return OrganizationService.deleteObjectOrProperty($scope.orgInfo.id, $scope.template.file);
    }

    $scope.resetTemplate = function() {
      let properties = [
        {
          'name': $scope.template.subject,
          'value': null,
          'privateContent': false
        }, {
          'name': $scope.template.title,
          'value': null,
          'privateContent': false
        }, {
          'name': $scope.template.subtitle,
          'value': null,
          'privateContent': false
        }, {
          'name': $scope.template.text,
          'value': null,
          'privateContent': false
        }, {
          'name': $scope.template.filename,
          'value': null,
          'privateContent': false
        }
      ];

      if ($scope.template.name.toLowerCase() != 'invite') {
        properties.push({
          'name': $scope.template.email,
          'value': '1',
          'privateContent': false
        });
      }

      removeTemplateFile()
        .then(data => {
          //  ToastsService.success(null, $t("orgs.new.messages.remove-success"));
        }, (data) => {
          // if (data.resultCode === 6) {
          //   ToastsService.warn(null, $t("orgs.new.messages.not-found-logo"));
          // }
        });

      saveOrgProperties(properties)
        .then(function(data) {
          $scope.progressText = null;
          $scope.subject = null;
          $scope.title = null;
          $scope.subtitle = null;
          $scope.text = null;
          $scope.filename = null;
          $scope.email = true;
          ToastsService.success(null, $t('settings.reset-template-success'));
        });

    };

    function saveOrgProperties(properties) {
      return OrganizationService.updateObjectsAndProperties($scope.orgInfo.id, properties);
    }

    function getOrgProperties(orgId) {
      return OrganizationService.getObjectsAndProperties(orgId);
    }

    let getProperties = function(orgProperties, parentProperties) {
      $scope.subject = getPropertyByName(orgProperties, 'subject');
      $scope.title = getPropertyByName(orgProperties, 'title');
      $scope.subtitle = getPropertyByName(orgProperties, 'subtitle');
      $scope.text = getPropertyByName(orgProperties, 'text');
      $scope.filename = getPropertyByName(orgProperties, 'filename');

      // It's enabled if undefined or null
      let emailEnabled = getPropertyByName(orgProperties, 'email');
      $scope.email = (!emailEnabled || emailEnabled === '1') ? true : false;
    };

    let getPropertyByName = function(orgProperties, paramName, inheritance) {
      return utils.getPropertyByName(orgProperties, $scope.template[paramName], true);

    };

    $scope.flowFileAddedHander = function($file, $event, $flow) {
      $scope.fileMessage = null;
      let flag = !!{ png: 1, gif: 1, jpg: 1, jpeg: 1, mp4: 1 }[$file.getExtension()];
      if (!flag) {
        ToastsService.warn(null, $t('settings.template.upload.type-tip'));
        return false;
      }
      let size = $file.size;
      if (size > 10 * 1024 * 1024) {
        ToastsService.warn(null, $t('settings.template.upload.size-tip'));
        return false;
      }
      return true;
    };

    $scope.flowFilesSubmittedHander = function($files, $event, $flow) {
      $scope.progressEvt = { loaded: 0 };
      if (!$files[0]) {
        $scope.file = null;
        $scope.fileMessage = null;
        $scope.progressText = null;
        return;
      }
      if (xhr) {
        xhr.abort();
      }
      $scope.file = $files[0];
      $scope.filename = $scope.file.name;
      updateProgressText(0, $scope.file.size, 0);
      uploadFileByAjax($scope.file, $scope.orgInfo.id, $scope.template.file);
    };

    let updateProgressText = function(loaded, size, progress) {
      let localStr = 'settings.template.upload.progress';
      if (progress == 100) {
        localStr = 'settings.template.upload.progress-done';
      }
      $scope.progressText = $t(localStr, {
        loaded: loaded,
        size: $filter('fileSize')(size),
        progress: progress
      });
    };

    let uploadProgress = function(evt) {
      $scope.$apply(function() {
        $scope.progressEvt = evt;
        let progress = Number(100 * evt.loaded / evt.total).toFixed(0);
        updateProgressText(evt.loaded, evt.total, progress == 100 ? 99 : progress);
      });
    };

    let createXhr = function() {
      let xhr = jQuery.ajaxSettings.xhr();
      xhr.upload.addEventListener('progress', uploadProgress, false);
      return xhr;
    };
    let xhr;
    let uploadFileByAjax = function($file, orgId, objectName) {
      $scope.uploadFinished = false;
      let apiKey = utils.getApiKey();
      let url = `${utils.getWebappHostUrlSync()}/admin/json/organizations/${orgId}/objects/${objectName}?private=false`;
      let headers = {};
      let type = $file.getType();
      let extension = $file.getExtension();
      if (type.toLowerCase() == 'mp4') {
        headers['Content-Type'] = 'video/mp4';
      } else {
        headers['Content-Type'] = 'image/' + type;
      }
      headers['API_KEY'] = apiKey;
      xhr = $.ajax({
        url: url,
        type: 'PUT',
        xhr: createXhr,
        headers: headers,
        data: $file.file,
        contentType: 'json',
        processData: false,
        complete: function() {
          $scope.$apply(function() {
            $scope.uploadFinished = true;
          });
        },
        success: function(data) {
          if (data.resultCode != 0) {}
          let properties = [
            {
              'name': $scope.template.filename,
              'value': $scope.file ? $scope.file.name : '',
              'privateContent': false
            }
          ];
          saveOrgProperties(properties)
            .then(function(data) {
              ToastsService.success(null, $t('settings.template.upload.success'));
              updateProgressText($scope.file.size, $scope.file.size, 100);
            });
        },
        error: function(jqXHR, textStatus, errorThrown) {
          if (errorThrown == 'abort') {
            return;
          } else if (errorThrown.message) {
            ToastsService.error(null, errorThrown.message);
          }
        }
      });
    };

    $scope.uploadFinished = true;
    let promise = getOrgProperties($scope.orgInfo.id).then(function(data) {
      if (data.resultCode != 0) {
        return;
      }
      $scope.orgProperties = data.organizationObjects;
      getProperties($scope.orgProperties);
    });

  }
}

export default angular
  .module('main.organizationsTemplate.controller', [])
  .controller('OrganizationsTemplateController', OrganizationsTemplateController)
  .name;
